import { ViewController } from 'ionic-angular/navigation/view-controller';

import { BllServisBilgisi } from './../../../providers/bll-servis-bilgisi';
import { Component } from '@angular/core';
import {   NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
import { NL_Servis } from '../../../models/NL_Servis';

/**
 * Generated class for the ServerConfigPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-server-config',
  templateUrl: 'server-config.html',
})
export class ServerConfigPage {
  sunucuAdresi = "";
  sunucuAdresiTanim="";
  sunucuAdresi2="";
  sunucuAdresi2Tanim="";

  constructor(public navCtrl: NavController,
public ortak:Ortak,
public viewCtrl:ViewController,
     public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.ServisAdresGetir();
  }

  ayarKaydet() {
    var bllServisBilgisi = new BllServisBilgisi();
    bllServisBilgisi.getAll().then(b => {
      var sonuc = <any>b;
      if (sonuc.length > 0) {
        var guncellenecekElement = new NL_Servis();
        guncellenecekElement.ADRES = this.sunucuAdresi;
        guncellenecekElement.ID = sonuc[0].ID;
        bllServisBilgisi.servisBilgisiGuncelle(guncellenecekElement);
        this.ortak.storageServisBilgisiEkle(guncellenecekElement);
        this.ortak.showBasicAlert("Bilgi", "Bağlantı bilgileri güncellendi. Kullanıcı adınız ve şifreniz ile sisteme giriş yapabilirsiniz.");
        this.viewCtrl.dismiss();
      }
      else {
        var servis = new NL_Servis();
        servis.ADRES = this.sunucuAdresi;
     
        bllServisBilgisi.add(servis);
        this.ortak.showBasicAlert("Bilgi", "Yeni servis kaydı yapıldı.");
        this.viewCtrl.dismiss();
      }
    });
  }
  ServisAdresGetir() {
    var bllServisBilgisi = new BllServisBilgisi();
    bllServisBilgisi.getAll({ ID: 1 }).then(a => {
      var sonuc = <any>a;
      this.sunucuAdresi = sonuc[0].ADRES;
      this.sunucuAdresiTanim=sonuc[0].Tanim;
      this.sunucuAdresi2=sonuc[0].ADRES;
    }).catch(x => {
     
    })
  }
  kapat()
  {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/server-config/server-config.ts